"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextPage = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./NextPage.scss");
var NextPage = function NextPage(_ref) {
  var total = _ref.total,
    current = _ref.current,
    _onClick = _ref.onClick,
    text = _ref.text,
    className = _ref.className;
  var Button = NextPage.Button,
    Icon = NextPage.Icon;
  if (current >= total) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-Pagination-NextPage', className)
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    onClick: function onClick() {
      return _onClick(current + 1);
    },
    size: Button.config.size.small,
    styleType: Button.config.styleType.light,
    className: "cds-Pagination-NextPageButton"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, text.nextPage, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: Icon.config.name.arrowRight,
    size: Icon.config.size.small,
    className: "cds-Pagination-NextPageIcon"
  }))));
};
exports.NextPage = NextPage;
NextPage.Icon = _Icon.Icon;
NextPage.Button = _Button.Button;